import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"pa-8 pb-2 fr-downloads-group",attrs:{"outlined":""}},[_c('h3',{staticClass:"mb-6"},[_vm._v(_vm._s(_vm.groupTitle))]),_c('ul',_vm._l((_vm.links),function(link,idx){return _c('li',{key:idx},[_c('DownloadLink',_vm._b({},'DownloadLink',link,false))],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }